// extracted by mini-css-extract-plugin
module.exports = {"title":"mutationMapBox_title__1azfT","subtitle":"mutationMapBox_subtitle__2hoPQ"};